import {
  Component,
  OnInit,
  OnDestroy,
  AfterViewInit,
  Inject,
  APP_ID,
  PLATFORM_ID,
  Directive,
  ElementRef,
} from "@angular/core";
import { Title } from "@angular/platform-browser";
import { BreadcrumbService, Breadcrumb } from "angular-crumbs";
import { isPlatformBrowser } from "@angular/common";
import { Router } from "@angular/router";
import { LanguageService } from "./services/i18n/raksme.languageService";

@Component({
  selector: "raksme-root",
  templateUrl: "./raksme.mainView.html",
  styleUrls: ["./raksme.mainStyle.css"],
})
export class MainComponent implements OnInit, OnDestroy, AfterViewInit {
  routerSubscription: any;

  public macClass: boolean = false;

  /**
   * The `/ar` suffix for links this shell renders - currently the floating
   * contact button, which must point at the contact page in the language the
   * visitor is actually reading.
   *
   * A getter, not a field set once in ngOnInit: this component is never
   * re-created, so a field would keep whichever language the first page load
   * happened to be and send an Arabic reader to the English contact page.
   */
  get lang(): string {
    return this.language.lang === "ar" ? "/ar" : "";
  }

  constructor(
    private titleService: Title,
    private breadcrumbService: BreadcrumbService,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(APP_ID) private appId: string,
    private router: Router,
    private language: LanguageService
  ) {}

  ngOnInit(): void {
    if (navigator.userAgent.indexOf("Mac") > 0) {
      this.macClass = true;
    }

    this.breadcrumbService.breadcrumbChanged.subscribe((crumbs) => {
      // this.titleService.setTitle(this.createTitle(crumbs));
    });

    // The URL is the only source of truth for language.
    //
    // What stood here read localStorage.RAKSME_LANG and rewrote the address
    // bar to match it, with window.location.href - a full page reload, not a
    // router navigation. It did harm in both directions: 'ar_AE' appended
    // '/ar' to whatever English URL you had opened, and 'en_US' STRIPPED '/ar'
    // from an Arabic one, which is exactly the reported symptom "a direct /ar
    // URL serves English". A shared link, a bookmark or a crawler therefore
    // got whichever language the last visitor to that browser had chosen.
    //
    // It also used url.includes('/ar'), a substring test that treats
    // /business-directory/12/architects as Arabic - the case
    // language-routes.ts documents.
    //
    // LanguageService reads the language from the route with
    // resolveLanguageUrls, and the language switcher sets the language BY
    // navigating. Nothing needs to persist a preference: the URL carries it,
    // which is what makes a link mean the same thing for everyone who opens it.
  }

  ngAfterViewInit() {}

  private createTitle(routesCollection: Breadcrumb[]) {
    const title = "RAK SME";
    const titles = routesCollection.filter((route) => route.displayName);

    if (!titles.length) {
      return title;
    }

    const routeTitle = this.titlesToString(titles);
    return `${routeTitle} ${title}`;
  }

  private titlesToString(titles) {
    return titles.reduce((prev, curr) => {
      return `${curr.displayName} - ${prev}`;
    }, "");
  }

  onActivate(event: any) {
    if (isPlatformBrowser(this.platformId)) {
      let scrollToTop = window.setInterval(() => {
        let pos = window.pageYOffset;
        if (pos > 0) {
          window.scrollTo(0, pos - 50); // how far to scroll on each step
        } else {
          window.clearInterval(scrollToTop);
        }
      }, 16);
    }
  }

  ngOnDestroy() {
    this.breadcrumbService.breadcrumbChanged.unsubscribe();
  }
}
